export function isNegative(n: number) {
    return n < 0
}

export function startsWithZeroOrNegative(n: string) {
    const regex = /^(?=.*[1-9])(?:[1-9]\d*\.?|0?\.)\d*$/
    return !regex.test(n)
}